exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".EZDrawer .EZDrawer__checkbox {\n    display: none;\n}\n.EZDrawer .EZDrawer__checkbox:checked ~ .EZDrawer__overlay {\n    display: block;\n    opacity: 1;\n}\n.EZDrawer .EZDrawer__checkbox:checked ~ .EZDrawer__container {\n    visibility: visible;\n    transform: translate3d(0, 0, 0) !important;\n}\n.EZDrawer .EZDrawer__overlay {\n    display: none;\n    height: 100vh;\n    left: 0;\n    position: fixed;\n    top: 0;\n    width: 100%;\n}\n.EZDrawer .EZDrawer__container {\n    position: fixed;\n    visibility: hidden;\n    background: white;\n    transition: all;\n    box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.1);\n}\n", ""]);

// exports
